module.exports = "<router-outlet></router-outlet>\r\n\r\n<!--\r\nver 4.0.0.0\r\n--> "


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main